"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentCardStatus = void 0;
var Utilities_1 = require("../../Utilities");
var DocumentCardStatus_base_1 = require("./DocumentCardStatus.base");
var DocumentCardStatus_styles_1 = require("./DocumentCardStatus.styles");
exports.DocumentCardStatus = Utilities_1.styled(DocumentCardStatus_base_1.DocumentCardStatusBase, DocumentCardStatus_styles_1.getStyles, undefined, { scope: 'DocumentCardStatus' });
//# sourceMappingURL=DocumentCardStatus.js.map